<template>
  <main>
    <section
      class="bg-main py-16 md:px-12 lg:px-2 p-4 max-w-screen-2xl mx-auto text-white mt-20 mb-12"
    >
      <div class="flex flex-col lg:flex-row gap-10 items-start mt-4">
        <div class="lg:w-1/2 lg:mt-5" ref="featureSection" v-motion="motionFadeUp">
          <img
            src="../assets/images/whycoacchingwork.jpg"
            alt="Why Coaching Works"
            class="w-full h-1/4 object-cover"
          />
        </div>

        <div class="lg:w-1/2">
          <h1 class="text-lg font-bold mt-8 lg:text-start">WHY COACHING WORKS</h1>
            <div class="flex items-center gap-5 mt-6">
                <div>
                    <i class="fa-solid fa-book text-lg"></i>
                </div>
                <div>
                    <h1 class="text-sm mb-2">Accountability</h1>
                    <p class="text-2xl text-[#bdbdbd]">Coaches hold individuals accountable for their actions and progress, providing support and encouragement to stay on track.</p>
                </div>
            </div>
            <div class="flex items-center gap-5 mt-6">
                <div>
                    <i class="fa-solid fa-wand-magic-sparkles text-lg"></i>
                </div>
                <div>
                    <h1 class="text-sm mb-2">Build Wealth</h1>
                    <p class="text-2xl text-[#bdbdbd]">Coaching helps in building wealth by offering personalized
                        guidance, financial education, and accountability. It helps
                        individuals navigate investment decisions, set achievable
                        goals, and maximize their financial potential.</p>
                </div>
            </div>
            <div class="flex items-center gap-5 mt-6">
                <div>
                    <i class="fa-solid fa-users text-lg"></i>
                </div>
                <div>
                    <h1 class="text-sm mb-2">Networking & Leverage Contact</h1>
                    <p class="text-2xl text-[#bdbdbd]">Coaching pitches on the significance of networking, teaching
                        individuals how to cultivate meaningful connections that can
                        be leveraged on for success.
                    </p>
                </div>
            </div>
            <div class="flex items-center gap-5 mt-4">
                <div>
                    <i class="fa-solid fa-gauge speed text-lg"></i>
                </div>
                <div>
                    <h1 class="text-sm mb-2">Business Development</h1>
                    <p class="text-2xl text-[#bdbdbd]">It guides entrepreneurs in identifying opportunities and
                        navigating challenges for sustainable growth and success.
                    </p>
                </div>
            </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
    import { motionFadeUp } from '@/motion';
    import { onMounted, ref } from 'vue';
export default {
    setup() {
      const featureSection = ref(null);

      onMounted(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.style.transition = "opacity 2s, transform 2s";
                entry.target.style.opacity = "1";
                entry.target.style.transform = "translateY(0)";
              } else {
                entry.target.style.opacity = "0";
                entry.target.style.transform = "translateY(0)";
              }
            });
          },
          {
            threshold: 0.1, // Adjust as needed
          }
        );

        observer.observe(featureSection.value);
      });

      return {
        motionFadeUp,
        featureSection,
      };
    },
};
</script>

<style scoped>
    .text-sm{
        font-size: 20px !important;
    }
    .text-2xl{
        font-size: 14px !important;
        line-height: 20px !important;
    }
</style>
